webpackJsonp([6],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(36);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _getContentRoot = __webpack_require__(91);
	
	var _getContentRoot2 = _interopRequireDefault(_getContentRoot);
	
	var _Window = __webpack_require__(83);
	
	var _Window2 = _interopRequireDefault(_Window);
	
	var _getTranslations = __webpack_require__(57);
	
	var _getTranslations2 = _interopRequireDefault(_getTranslations);
	
	var _acura = __webpack_require__(67);
	
	var _acura2 = _interopRequireDefault(_acura);
	
	var _readConfigData = __webpack_require__(64);
	
	var _readConfigData2 = _interopRequireDefault(_readConfigData);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * ResetPassword page
	 *
	 */
	var config = (0, _readConfigData2.default)('acura-config');
	
	var app = (0, _lodash.assign)({}, {
	  theme: _acura2.default,
	  isDesktop: false,
	  isMobile: false,
	  isResponsive: true,
	  modelsNavList: [],
	  env: ("production"),
	  version: ("3.4.5"),
	  outerContainerId: 'hui-layout-container',
	  pageWrapId: 'hui-content-container',
	  menuPanelWidth: 390,
	  vehiclePanelWidth: 780,
	  translations: (0, _getTranslations2.default)(config.language)
	}, config);
	
	renderApp(app);
	
	function renderApp(props) {
	  _reactDom2.default.render(_react2.default.createElement(
	    _Window2.default,
	    props,
	    _react2.default.createElement('input', { id: 'current-page', type: 'hidden', value: 'resetPasswordApp' }),
	    _react2.default.createElement(
	      'div',
	      { id: 'resetPasswordApp', 'data-ng-cloak': true },
	      _react2.default.createElement(
	        'reset-password-app',
	        null,
	        'Loading...'
	      )
	    )
	  ), (0, _getContentRoot2.default)('root'));
	}

/***/ })
]);


// WEBPACK FOOTER //
// resetPassword.js